import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const unidadeSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape(
    {
      nome: Yup.string().trim().required('Nome é obrigatório'),
      codigo: Yup.string().trim().required('Codigo é obrigatório'),
      empresa: Yup.object()
        .nullable()
        .when('ativa', {
          is: (val: { label: string; value: boolean } | undefined) => val === undefined,
          then: (schema) => schema.required(v.requiredField('empresa', 'select')),
          otherwise: (schema) => schema.notRequired(),
        }),
      tipoUnidade: Yup.object().nullable().required('Necessário selecionar um tipo de unidade'),
      grupoTelegram: Yup.string().trim().notRequired(),
      especialidades: Yup.array().of(Yup.object().nullable()).nullable().notRequired(),
      sus: Yup.boolean()
        .required('Selecione uma opção')
        .oneOf([true, false], 'Selecione uma opção')
        .nullable(),
      // Obrigatórios quando atende SUS, ou quando o outro campo do par foi preenchido
      nomeCnes: Yup.string()
        .trim()
        .when(['sus', 'cnes'], {
          is: (sus: boolean, cnes?: string) => sus || !!cnes?.trim(),
          then: (schema) => schema.required('Nome do CNES obrigatório'),
          otherwise: (schema) => schema.notRequired(),
        }),
      cnes: Yup.string()
        .trim()
        .matches(/^\d{7}$/, { message: 'Formato inválido', excludeEmptyString: true })
        .when(['sus', 'nomeCnes'], {
          is: (sus: boolean, nomeCnes?: string) => sus || !!nomeCnes?.trim(),
          then: (schema) => schema.required('CNES obrigatório'),
          otherwise: (schema) => schema.notRequired(),
        }),
      codigoIbge: Yup.string()
        .trim()
        .nullable()
        .notRequired()
        .test(
          'codigoIbgeFormat',
          'Código IBGE deve conter exatamente 7 dígitos numéricos',
          (val) => !val || /^\d{7}$/.test(val)
        ),
      ativa: Yup.object(),
      emailContato: Yup.string().email('E-mail inválido').notRequired(),
      telefoneContato: Yup.string()
        .trim()
        .matches(
          /^\(\d{2}\) (\d )?\d{4}-\d{4}$/,
          'Formato deve ser (00) 0000-0000 ou (00) 0 0000-0000'
        )
        .required('O telefone de contato é obrigatório'),

      observacoes: Yup.array()
        .of(Yup.string().trim().required('Necessário preencher observação'))
        .default([]),
    },
    // nomeCnes e cnes dependem um do outro; sem isso o Yup acusa dependência cíclica
    [['nomeCnes', 'cnes']]
  )
}
